import { useState, useEffect } from 'react'
import { getDepartmentsAPI } from '../services/departments'

function UseDepartmentsAll(orgId, divisionId, factionId, departmentId) {
  const [data, setData] = useState([])
  useEffect(() => {
    const param = {
      orgId,
      divisionId,
      factionId
    }
    const getData = async () => {
      const resp = await getDepartmentsAPI(param)
      if (!resp) return

      if (resp.status) {
        const newData =
          resp.result.length > 0 &&
          resp.result.map((d, i) => {
            return {
              value: d?.id,
              label: `${d?.department_en} (${d?.department})`,
              count_emp: d?.count_emp,
              data: d?.department
            }
          })

        setData(newData)
      }
    }
    if (orgId && (divisionId || factionId)) {
      getData()
    }
  }, [orgId, factionId, divisionId])

  return data
}

export default UseDepartmentsAll
